export default "__VITE_ASSET__62cdd13c__"